'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createContentMetaDataMap = createContentMetaDataMap;
exports.appendContentMetaData = appendContentMetaData;
exports.mergeRecommendations = mergeRecommendations;
exports.createLastPageNumberForCategoriesObject = createLastPageNumberForCategoriesObject;
exports.createCurrentPageNumberForCategoriesObject = createCurrentPageNumberForCategoriesObject;

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _logging = require('../lib/app/logging');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base64 = require('base-64');

var logger = (0, _logging.appLogger)().create('recommendations operations');

function createPopularObject(res) {
  var categoryObj = {};
  var categoriesObj = {};
  var typeObject = {};
  var typeInLowerCase = res.type.toLowerCase();
  categoryObj[res.category] = res.recommendations;
  categoriesObj.categories = categoryObj;
  typeObject[typeInLowerCase] = categoriesObj;

  return typeObject;
};

function createContentMetaDataMap(contentMetaData, recommendations) {
  var newContentMetaData = new Map(contentMetaData);
  var manipulatedRecommendationsObject = createPopularObject(recommendations);
  var categoriesObject = manipulatedRecommendationsObject.popular && manipulatedRecommendationsObject.popular.categories ? manipulatedRecommendationsObject.popular.categories : {};

  Object.keys(categoriesObject).forEach(function (key) {
    var objArray = categoriesObject[key] ? categoriesObject[key] : [];
    (objArray || []).forEach(function (obj) {
      obj.category ? delete obj.category : null;
      var contentKey = obj.contentKey;
      var content = contentKey ? newContentMetaData.get(contentKey) : null;
      obj.decodedData = base64.decode(obj.encodedData);

      content ? newContentMetaData.set(contentKey, Object.assign(content, obj)) : newContentMetaData.set(contentKey, obj);
    });
  });

  return newContentMetaData;
}

/**
 * Helper function to combine channels and contents info
 * @param contentMetaData
 * @param channelsInfo
 */
function appendContentMetaData(contentMetaData, channelsInfo) {
  var newContentMetaData = new Map(contentMetaData);
  (channelsInfo || []).forEach(function (item) {
    if (newContentMetaData && item && item.contentKey) {
      var contentKey = item.contentKey;
      var content = newContentMetaData.get(contentKey);

      content ? newContentMetaData.set(contentKey, Object.assign(content, item)) : newContentMetaData.set(contentKey, item);
    }
  });

  return newContentMetaData;
}

function mergeRecommendations(state, response) {
  var responseManipulated = createPopularObject(response);
  var currentRecommendations = Object.assign({}, state.recommendations);
  return (0, _deepmerge2.default)(currentRecommendations, responseManipulated);
}

function createLastPageNumberForCategoriesObject(state, response) {
  var newLastPageNumberForCategoriesObject = new Map(state.lastPageNumbersForCategories);
  newLastPageNumberForCategoriesObject.set(response.category, response.lastPageNumber);
  return newLastPageNumberForCategoriesObject;
}

function createCurrentPageNumberForCategoriesObject(state, response) {
  var newCurrentPageNumberForCategoriesObject = new Map(state.currentPageNumberForCategories);
  newCurrentPageNumberForCategoriesObject.set(response.category, response.pageNumber);
  return newCurrentPageNumberForCategoriesObject;
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/operations/recommendations.js
// module id = 770
// module chunks = 0